import type { PickListOption } from '@/common/api/types/picklistOption';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';

export const PickListCell = ({ value }: { value?: PickListOption }) =>
  value?.name && <OverflowTooltip>{value.name}</OverflowTooltip>;
